function discountMetaSideMatches(metaItem, side, productId, variantId) {
  const matcher = window.theme?.discountMeta?.sideMatches;
  if (typeof matcher === 'function') {
    return matcher(metaItem, side, productId, variantId);
  }
  const products = metaItem?.[`products_${side}`];
  return Array.isArray(products) && products.some((product) => product.id == productId);
}

function discountMetaApplyBuy1Off(price, metaItem) {
  const apply = window.theme?.discountMeta?.applyBuy1Off;
  if (typeof apply === 'function') {
    return apply(price, metaItem);
  }
  const off = Number(metaItem?.off) || 0;
  return (Number(price) || 0) * (1 - off);
}

function discountMetaAmountOffPairs(metaItem, productIdA, productIdB) {
  const listHas = (list, productId) =>
    Array.isArray(list) && list.some((product) => product.id == productId);
  return (
    (listHas(metaItem?.products_1, productIdA) && listHas(metaItem?.products_2, productIdB)) ||
    (listHas(metaItem?.products_1, productIdB) && listHas(metaItem?.products_2, productIdA))
  );
}

if (!customElements.get('product-bundle-kit')) {
  class ProductBundleV2 extends HTMLElement {
    /**
     * Section settings
     */
    sectionSettings;

    /**
     * Swiper entity
     *
     * @type {Swiper}
     */
    mySwiper;

    constructor() {
      super();
    }

    init() {
      this.autoSelectOption = this.getAttribute('data-auto-select-option') == 'true';
      window.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
          this.selectSameOption(document.querySelector('radio-swatch input:checked+label'));
        }, 1);
      });
      if (this.autoSelectOption) {
        document.addEventListener('click', (e) => {
          const label = e.target.closest('radio-swatch label');
          if (!label || this.contains(label)) return;
          this.selectSameOption(label);
        });
      }
      document.addEventListener('theme:variant:change', () => this.updateItemsPrice());
      this.initOnlySwiper(0);
    }

    /** bundle 产品跟随主产品的相同名称选项，自动切换到一样的选项 */
    selectSameOption(labelElement) {
      if (!labelElement) return;
      const value = labelElement.getAttribute('data-swatch');
      if (!value) return;

      const bundleItems = this.querySelectorAll('product-bundle-kit-item-v2');
      for (const bundle of bundleItems) {
        const matchingInput = Array.from(
          bundle.querySelectorAll('input[type="radio"]')
        ).find((input) => String(input.value).trim() === String(value).trim());

        if (matchingInput && !matchingInput.checked) {
          matchingInput.checked = true;
          matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    /**
     * 初始化 Swiper
     */
    initOnlySwiper() {
      this.mySwiper?.destroy();
      this.mySwiper = new Swiper(this.querySelector(`.swiper`), {
        loop: false,
        slidesPerView: 'auto',
        observer: true,
        resizeObserver: true,
        navigation: {
          nextEl: this.querySelector(`.swiper-btn-next`),
          prevEl: this.querySelector(`.swiper-btn-prev`),
        },
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true,
        }
      });
    }

    /** 更新所有子项的价格 */
    updateItemsPrice() {
      for (const item of this.querySelectorAll('product-bundle-kit-item-v2')) {
        item.updatePrice?.();
      }
      this.notifyMainButtonPriceUpdate();
    }

    /**
     * 返回已勾选且可售的 bundle 变体，供主产品加购时一并加入购物车
     * @returns {Array<{id: number, quantity: number}>}
     */
    getCheckedCartItems(quantity = 1) {
      const qty = Number(quantity) > 0 ? Number(quantity) : 1;
      const items = [];

      for (const item of this.querySelectorAll('product-bundle-kit-item-v2')) {
        const cartItem = item.getCheckedCartItem?.(qty);
        if (cartItem) items.push(cartItem);
      }

      return items;
    }

    /**
     * 已勾选 bundle 的产品/变体详情
     * @returns {Array<{productId: number|string, variant: object}>}
     */
    getCheckedItemDetails() {
      const items = [];
      for (const el of this.querySelectorAll('product-bundle-kit-item-v2')) {
        if (el.checkbox?.checked && el.variant?.available) {
          items.push({
            productId: el.product.id,
            variant: el.variant,
          });
        }
      }
      return items;
    }

    /**
     * 计算勾选 bundle 后主加购按钮应展示的价格（含折扣）
     * @param {{ mainProductId: number|string, mainVariantId?: number|string, mainPartPrice: number, mainPartComparePrice: number }} params
     * @returns {{ price: number, comparePrice: number } | null}
     */
    getCheckedPriceAdjustment({ mainProductId, mainVariantId, mainPartPrice, mainPartComparePrice }) {
      const checkedItems = this.getCheckedItemDetails();
      if (!checkedItems.length) return null;

      let bundlePart = 0;
      let bundleComparePart = 0;
      for (const item of checkedItems) {
        const price = Number(item.variant.price) || 0;
        const compareAt = Number(item.variant.compare_at_price) || 0;
        bundlePart += price;
        bundleComparePart += compareAt > price ? compareAt : price;
      }

      const mainPart = Number(mainPartPrice) || 0;
      const mainComparePart = Number(mainPartComparePrice) || mainPart;
      const basePrice = mainPart + bundlePart;
      const comparePrice = mainComparePart + bundleComparePart;
      const metaCandidates = [];

      // buy_1_get_1_off：买 1 打 Products 2 中的 1 件，多条规则折优
      if (window.theme.discountMeta?.buy_1_get_1_off?.length) {
        for (const metaItem of window.theme.discountMeta.buy_1_get_1_off) {
          if (!discountMetaSideMatches(metaItem, 1, mainProductId, mainVariantId)) continue;

          const eligibleIndexes = [];
          checkedItems.forEach((item, index) => {
            if (discountMetaSideMatches(metaItem, 2, item.productId, item.variant?.id)) {
              eligibleIndexes.push(index);
            }
          });
          if (!eligibleIndexes.length) continue;

          // 多件都在 Products 2 时只打 1 件，取让合计最低的那件
          let bestBundleSum = Infinity;
          for (const offIndex of eligibleIndexes) {
            let bundleSum = 0;
            checkedItems.forEach((item, index) => {
              const itemPrice = Number(item.variant.price) || 0;
              bundleSum +=
                index === offIndex
                  ? discountMetaApplyBuy1Off(itemPrice, metaItem)
                  : itemPrice;
            });
            if (bundleSum < bestBundleSum) bestBundleSum = bundleSum;
          }

          metaCandidates.push(Math.ceil(mainPart + bestBundleSum));
        }
      }

      // amount_off_products_bundle：配对成功则对合计打折，多条及与 buy_1 之间折优
      if (window.theme.discountMeta?.amount_off_products_bundle?.length) {
        for (const metaItem of window.theme.discountMeta.amount_off_products_bundle) {
          const off = Number(metaItem.off) || 0;
          const pairs = checkedItems.some((item) =>
            discountMetaAmountOffPairs(metaItem, mainProductId, item.productId)
          );
          if (pairs) {
            metaCandidates.push(Math.ceil(basePrice * (1 - off)));
          }
        }
      }

      const bestMetaPrice =
        metaCandidates.length > 0 ? Math.min(basePrice, ...metaCandidates) : basePrice;
      const metaOff = basePrice > 0 ? Math.max(0, 1 - bestMetaPrice / basePrice) : 0;
      const discountOff = Math.max(0, Math.min(1, Number(this.getAttribute('data-discount-off')) || 0));
      // 取折扣力度更大的那个
      const finalOff = Math.max(metaOff, discountOff);
      const finalPrice = Math.ceil(basePrice * (1 - finalOff));

      return {
        price: finalPrice,
        comparePrice,
      };
    }

    notifyMainButtonPriceUpdate() {
      const productId = this.getAttribute('data-product-id');
      const scope = this.closest('.shopify-section') || document;

      // 同步更新同产品页内所有加购按钮（主布局 + B 布局）
      scope.querySelectorAll('product-form').forEach((productForm) => {
        if (
          productId &&
          productForm.productJSON?.id != null &&
          String(productForm.productJSON.id) !== String(productId)
        ) {
          return;
        }
        if (
          productForm?.productForm &&
          typeof productForm.updateButtonPrices === 'function'
        ) {
          productForm.updateButtonPrices(productForm.productForm.getFormState());
        }
      });
    }

    connectedCallback() {
      this.observeElement(this, this.handleInViewport.bind(this));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    handleInViewport() {
      this.init();
    }

    observeElement(element, callback) {
      const observer = new IntersectionObserver(
        (entries, observerInstance) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              callback();
              observerInstance.unobserve(entry.target);
            }
          });
        },
        {
          root: null,
          threshold: 0.5,
        }
      );
      if (this.isElementInViewport(element)) {
        callback();
        return;
      }
      observer.observe(element);
      this.observer = observer;
    }

    isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top < window.innerHeight &&
        rect.bottom > 0 &&
        rect.left < window.innerWidth &&
        rect.right > 0
      );
    }
  }

  customElements.define('product-bundle-kit', ProductBundleV2);
}

if (!customElements.get('product-bundle-kit-item-v2')) {
  class ProductBundleKitItem extends HTMLElement {
    constructor() {
      super();
      this.product = this.parseProductJSON();
      this.variant =
        this.product?.variants?.find((v) => v.available) ?? this.product?.variants?.[0];
      this.productImage = this.querySelector('[data-product-image]');
      this.price = this.querySelector('[data-price]');
      this.comparePrice = this.querySelector('[data-compare-price]');
      this.select = this.querySelector('[data-variant-select]');
      this.form = this.querySelector('[data-bundle-item-form]');
      this.checkbox = this.querySelector('[data-bundle-checkbox]');
      this.bundlePriceLabel = this.querySelector('[data-bundle-price]');
      this.bundleComparePriceLabel = this.querySelector('[data-bundle-compare-price]');
      this.addCartButton = this.querySelector('[data-add-cart-button]');

      this.showDialogButtons = this.querySelectorAll('[data-show-dialog-button]');
      this.bundleId = `product-bundle-kit-item__${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
      this.setAttribute('data-id', this.bundleId);
      this.setAttribute('data-product-bundle-kit-id', this.bundleId);

      this.outerWrapper = this.closest('[data-section-id]');
      const outerProductJsonEl = this.outerWrapper?.querySelector(
        '[data-product-form] [data-product-json], [data-product-form-outer] [data-product-json]'
      );
      this.outerProductJSON = outerProductJsonEl
        ? JSON.parse(outerProductJsonEl.innerHTML)
        : null;
      this.outerVariantInput = this.outerWrapper?.querySelector(
        `[data-product-form-outer] input[name="id"]`
      );
      this.outerQuantity = this.outerWrapper?.querySelector('[data-quantity-input]');

      if (this.select?.value && this.product?.variants) {
        const selectedVariant = this.product.variants.find(
          (v) => String(v.id) === String(this.select.value)
        );
        if (selectedVariant) this.variant = selectedVariant;
      }

      this.syncCheckboxState();
      this.updatePrice();
      this.initEvent();
    }

    parseProductJSON() {
      const jsonEl = this.querySelector('[data-grid-product-json]');
      if (!jsonEl?.innerHTML) {
        console.warn('[ProductBundleItemV2] Missing product-grid-json');
        return null;
      }
      try {
        return JSON.parse(jsonEl.innerHTML);
      } catch (error) {
        console.error('[ProductBundleItemV2] Failed to parse product JSON', error);
        return null;
      }
    }

    initEvent() {
      // 变体切换由 product-grid-variant-options 处理，并通过 select change 通知
      this.select?.addEventListener('change', (e) => {
        this.changeVariant(e.target.value);
      });

      this.checkbox?.addEventListener('change', () => {
        this.notifyMainButtonPriceUpdate();
      });

      this.addCartButton?.addEventListener('click', (e) => {
        e.target.classList.add('loading');
        const mainVariantId =
          this.getParameterFromUrl('variant', window.location.href) ??
          JSON.parse(document.querySelector('[data-product-json]').innerText).variants[0]
            .id;
        this.addToCart([
          { id: mainVariantId, quantity: 1 },
          { id: this.getSelectedVariantId(), quantity: 1 },
        ]).then(async () => {
          e.target.classList.remove('loading');
          const cart = await fetch(`${window.theme.routes.cart}.js`).then((r) => r.json());
          document.dispatchEvent(
            new CustomEvent('theme:cart:change', {
              detail: { cart },
              bubbles: true,
            })
          );
          const drawer = document.querySelector("[data-drawer='drawer-cart']");
          if (drawer) {
            drawer.dispatchEvent(
              new CustomEvent('theme:drawer:toggle', {
                bubbles: false,
              })
            );
          }
          if (typeof monster_refresh === 'function') monster_refresh(true);
        });
      });

      this.outerQuantity?.addEventListener('change', () => {
        this.updatePrice();
      });

      for (const el of this.showDialogButtons) {
        el.addEventListener('click', () => this.showDialog());
      }
    }

    getSelectedVariantId() {
      return this.variant?.id || this.select?.value || null;
    }

    getCheckedCartItem(quantity = 1) {
      if (!this.checkbox?.checked) return null;
      if (!this.variant?.available) return null;

      const id = Number(this.getSelectedVariantId());
      if (!Number.isFinite(id) || id <= 0) return null;

      return {
        id,
        quantity: Number(quantity) > 0 ? Number(quantity) : 1,
      };
    }

    syncCheckboxState() {
      if (!this.checkbox) return;
      this.checkbox.value = this.variant?.id || '';
      if (this.variant?.available) {
        this.checkbox.removeAttribute('disabled');
      } else {
        this.checkbox.checked = false;
        this.checkbox.setAttribute('disabled', '');
      }
    }

    notifyMainButtonPriceUpdate() {
      this.closest('product-bundle-kit')?.notifyMainButtonPriceUpdate?.();
    }

    showDialog() {
      window.theme.dialogs?.openQuickview(this.product?.handle);
    }

    updatePrice(outerQuantity = 1) {
      if (!this.bundlePriceLabel || !this.outerVariantInput || !this.outerProductJSON) {
        return;
      }

      const outerVariant = this.outerProductJSON.variants.find(
        (v) => v.id == this.outerVariantInput.value
      );
      if (!outerVariant || !this.variant) return;

      const outerPrice = outerVariant.price;
      const outerComparePrice = outerVariant.compare_at_price;
      const price = this.variant.price;
      const comparePrice = this.variant.compare_at_price;
      let bothPrice = (outerPrice + price) * outerQuantity;
      let bothComparePrice =
        ((outerPrice < outerComparePrice ? outerComparePrice : outerPrice) +
          (price < comparePrice ? comparePrice : price)) *
        outerQuantity;

      const comboBase = (outerPrice + price) * outerQuantity;
      const priceList = [];

      if (window.theme.discountMeta?.buy_1_get_1_off?.length) {
        for (const metaItem of window.theme.discountMeta.buy_1_get_1_off) {
          if (
            discountMetaSideMatches(metaItem, 1, this.outerProductJSON.id, outerVariant.id) &&
            discountMetaSideMatches(metaItem, 2, this.product.id, this.variant.id)
          ) {
            priceList.push(
              Math.ceil((outerPrice + discountMetaApplyBuy1Off(price, metaItem)) * outerQuantity)
            );
          }
        }
      }

      if (window.theme.discountMeta?.amount_off_products_bundle?.length) {
        for (const metaItem of window.theme.discountMeta.amount_off_products_bundle) {
          if (discountMetaAmountOffPairs(metaItem, this.outerProductJSON.id, this.product.id)) {
            priceList.push(Math.ceil(comboBase * (1 - (Number(metaItem.off) || 0))));
          }
        }
      }

      if (priceList.length > 0) {
        bothPrice = Math.min(...priceList);
      }

      this.bundlePriceLabel.innerHTML = this.formattingMoney(bothPrice);
      if (this.bundleComparePriceLabel) {
        this.bundleComparePriceLabel.innerHTML =
          bothPrice < bothComparePrice ? this.formattingMoney(bothComparePrice) : '';
      }
    }

    formattingMoney(money) {
      if (theme.settings.currency_code_enable) {
        return (
          themeVendor.themeCurrency.formatMoney(money, theme.moneyFormat) +
          ` ${theme.currencyCode}`
        );
      }
      return themeVendor.themeCurrency.formatMoney(money, theme.moneyFormat);
    }

    changeVariantIfAvailable(variantId) {
      const variant =
        this.product.variants.find((v) => v.id == variantId) ?? this.product.variants[0];
      if (variant && variant.available) {
        this.changeVariant(variantId);
      }
    }

    changeVariant(variantId) {
      const variant =
        this.product.variants.find((v) => String(v.id) === String(variantId)) ??
        this.product.variants[0];
      this.variant = variant;

      if (!variant) {
        console.error(`variant for id: ${variantId} not found.`);
        return;
      }

      if (this.select && String(this.select.value) !== String(variant.id)) {
        this.select.value = variant.id;
      }

      let src =
        variant.featured_media?.preview_image?.src ??
        this.product?.featured_media?.preview_image?.src;
      if (src) {
        src = String(src);
        src.includes('?') ? (src += '&width=200') : (src += '?width=200');
        if (this.productImage) {
          this.productImage.src = src;
        }
      }

      if (this.price) {
        this.price.innerHTML = themeVendor.themeCurrency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      if (this.comparePrice) {
        if (variant.compare_at_price && variant.price < variant.compare_at_price) {
          this.comparePrice.innerHTML = themeVendor.themeCurrency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          );
        } else {
          this.comparePrice.innerHTML = '';
        }
      }

      if (this.addCartButton) {
        if (variant.available) {
          this.addCartButton.removeAttribute('disabled');
        } else {
          this.addCartButton.setAttribute('disabled', '');
        }
      }

      this.syncCheckboxState();
      this.updatePrice();
      this.notifyMainButtonPriceUpdate();
    }

    /**
     * 加购
     * @param {[{id: string, quantity: number}]} items
     */
    async addToCart(items) {
      const formData = {
        items: items,
      };
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }

    getParameterFromUrl(name, url) {
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }

  customElements.define('product-bundle-kit-item-v2', ProductBundleKitItem);
}
